export const childrenInDaycare = (ages) => {
    return ages.reduce((total, current) => {
        return total + (current < 14 ? 1 : 0);
    }, 0)
};

export const childrenInSchool = (ages) => {
    return ages.reduce((total, current) => {
        return total + (current > 5 ? 1 : 0);
    }, 0)
};

export const capitalise = (word) => {
    return `${word.slice(0,1).toUpperCase()}${word.slice(1)}`;
};